import { IconButton, SwipeableDrawer } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Sheet = styled(SwipeableDrawer)(({ theme }) => ({
  "& .MuiDrawer-paper": {
    display: "flex",
    flexDirection: "column",
    maxHeight: "92dvh",
    padding: theme.spacing(1.5, 2.5, 2.5),
    borderRadius: "16px 16px 0 0",
    background: theme.palette.background.paper,
    overflowY: "auto",
  },
}));

export const Puller = styled("span")(({ theme }) => ({
  flexShrink: 0,
  width: 40,
  height: 4,
  margin: "0 auto 16px",
  borderRadius: 2,
  backgroundColor: theme.palette.divider,
}));

export const CloseButton = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  top: 16,
  right: 14,
  width: 30,
  height: 30,
  backgroundColor: theme.palette.action.hover,
  color: theme.palette.text.secondary,

  "& svg": {
    width: 18,
    height: 18,
  },
}));
